import { NavLink, Outlet, Link } from "react-router-dom";
import { ClipboardList, SlidersHorizontal, Images, LogOut, ExternalLink } from "lucide-react";
import { useLang } from "@/lib/i18n";
import { useAuth } from "@/lib/auth";
import { LangToggle } from "@/components/SiteHeader";

export default function AdminLayout() {
  const { t } = useLang();
  const { logout } = useAuth();
  const links = [
    { to: "/admin", end: true, icon: ClipboardList, label: t("admin.orders"), id: "admin-nav-orders" },
    { to: "/admin/gallery", icon: Images, label: t("admin.gallery"), id: "admin-nav-gallery" },
    { to: "/admin/settings", icon: SlidersHorizontal, label: t("admin.settings"), id: "admin-nav-settings" },
  ];
  return (
    <div className="min-h-screen lg:grid lg:grid-cols-[240px_1fr]" data-testid="admin-layout">
      <aside className="border-b border-white/10 bg-ink lg:sticky lg:top-0 lg:h-screen lg:border-b-0 lg:border-r">
        <div className="flex items-center gap-3 p-5">
          <img src="/brand/logo-sm.png" alt="" className="h-10 w-auto" />
          <span className="font-display leading-tight">MC Illusions<span className="block text-[10px] font-sans font-extrabold tracking-[0.3em] text-ruby">ADMIN</span></span>
        </div>
        <nav className="flex gap-1 overflow-x-auto px-3 pb-3 lg:flex-col">
          {links.map(({ to, end, icon: Icon, label, id }) => (
            <NavLink key={id} to={to} end={end} data-testid={id}
              className={({ isActive }) => `flex items-center gap-3 whitespace-nowrap rounded-md px-3 py-2.5 text-sm font-bold transition-colors ${isActive ? "bg-gold text-ink" : "text-slate-300 hover:bg-white/5"}`}>
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="flex items-center gap-3 px-5 pb-5 lg:absolute lg:bottom-0 lg:w-[240px] lg:flex-col lg:items-start">
          <LangToggle />
          <Link to="/" className="flex items-center gap-2 text-sm font-semibold text-slate-400 hover:text-white" data-testid="admin-view-site"><ExternalLink className="h-4 w-4" /> {t("admin.view_site")}</Link>
          <button onClick={logout} className="flex items-center gap-2 text-sm font-semibold text-slate-400 hover:text-ruby" data-testid="admin-logout-btn"><LogOut className="h-4 w-4" /> {t("admin.logout")}</button>
        </div>
      </aside>
      <main className="min-w-0 p-5 lg:p-10"><Outlet /></main>
    </div>
  );
}
